import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import ColorContext from '@providers/ColorProvider/context/ColorContext';
import { Link } from '@stackflow/link';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import coolImg from './cool_img.png';
import PlusIcon from './PlusIcon';
import styles from './styles.module.scss';
import warmImg from './warm_img.png';

function Blank() {
    const { t } = useTranslation('prepaidCard');
    const { grayTheme } = useContext(ColorContext);
    return (
        <Column className={styles.container}
            fullWidth
            as='section'
            align='center'>
            <Image src={grayTheme === 'WARM' ? warmImg : coolImg}
                className={styles.img}
                width={256}
                height={256}
                alt={t('blank.imageAlt')} />
            <Text size='lg'>{t('blank.noCard')}</Text>
            <Link activityParams={{ type: 'BUY' }}
                activityName='PrepaidCardImagesActivity' >
                <Column className={styles.card}
                    justify='center'
                    align='center'
                    spacing={4} >
                    <button className={styles.add}>
                        <PlusIcon/>
                    </button>
                    <Text size='lg'>{t('blank.buyNewCard')}</Text>
                </Column>
            </Link>
        </Column>
    );
}
export default Blank;
